import React, { useState } from 'react';
import {
  Row,
  Col,
  Input,
  Typography,
  Table,
  Space,
  Skeleton,
  Result
} from 'antd';
import {
  FaSearch,
} from "react-icons/fa"; //Font Awesome 5
import DeletePopupButton from './components/DeletePopupButton';
import EditFormModal from './components/EditFormModal';
import AddFormModal from './components/AddFormModal';

import { useQuery } from '@tanstack/react-query';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    width: '80%',
    render: (_, record) => (
      <Space size="small">
        <EditFormModal data={record} />
        <DeletePopupButton data={record} />
      </Space>
    ),
  }
]

function List() {
  const [filterData, setFilterData] = useState(null);
  const { isError, isLoading, data, error } = useQuery({
    queryKey: ['/api/categories/'],
  })


  if (isLoading) {
    return <Skeleton active />
  }

  if (isError) {
    return <Result status="error" title={error.message} />
  };

  const onSearch = e => {
    const s = e.target.value;
    const target = data.filter(f => f.name.includes(s))
    setFilterData(target);
  }

  // console.log('data :', data);

  return (
    <div >
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            Categories
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Row justify='space-between' gutter={[16, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Input placeholder="Search" prefix={<FaSearch />} onChange={onSearch} />
            </Col>
            <Col xs={24} sm={12}>
              <Row justify='end'>
                <Col>
                  <AddFormModal />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={24}>
          <Table
            rowKey={(record) => record._id}
            columns={columns}
            dataSource={filterData || data}
            scroll={{
              x: 1200,
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default List